import React, { CSSProperties, PropsWithChildren } from "react";
import { Offcanvas, OffcanvasProps } from "react-bootstrap";

import "./BottomDrawer.scss";
import XIcon from "../icons/XIcon";
import { GenericModalProps } from "../../utils/constants/generic-types";

interface BottomDrawerProps extends GenericModalProps {
  heading?: React.ReactNode;
  containerClass?: string;
  headingClass?: string;
  bodyClass?: string;
  showCloseBtn?: boolean;
  closeBtnStyles?: CSSProperties;
}

export default function BottomDrawer({
  children,
  isOpen,
  onClose,
  heading,
  headingClass = "",
  bodyClass = "",
  closeBtnStyles,
  showCloseBtn = true,
  containerClass = "",
  ...props
}: PropsWithChildren<BottomDrawerProps & OffcanvasProps>) {
  return (
    <Offcanvas
      placement="bottom"
      show={isOpen}
      onHide={onClose}
      className={`MobileOnly BottomDrawer ${containerClass}`}
      {...props}
    >
      <Offcanvas.Header
        className={`p-0 justify-content-between ${headingClass}`}
        style={{ minHeight: showCloseBtn ? 35 : 0 }}
      >
        {showCloseBtn && (
          <button
            aria-label="Close dialog"
            onClick={onClose}
            className="CloseButton"
            style={closeBtnStyles}
          >
            <XIcon strokeColor="#F7F7F7" bgColor="#FFFFFF17" />
          </button>
        )}
        <Offcanvas.Title className="flex-grow-1 h-100">
          {heading}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className={bodyClass}>{children}</Offcanvas.Body>
    </Offcanvas>
  );
}
